import {
  isLocalAuthDisabled,
  localBeehiveOnlineContactId,
  localB2CUserId,
  localDatabaseName,
} from "./localRuntime";

const baseUri = process.env.REACT_APP_PAY_PORTAL_API_URL;
const apicultureUrl = process.env.REACT_APP_PAY_PORTAL_APICULTURE_URL;

const isAuthDisabled = isLocalAuthDisabled;
const beehiveContactId = localBeehiveOnlineContactId;
const b2cUserId = localB2CUserId;
const databaseName = localDatabaseName;

const buildHeaders = (token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (beehiveContactId) {
    headers["beehive-contact-id"] = beehiveContactId;
  }

  if (b2cUserId) {
    headers["b2c-user-id"] = b2cUserId;
  }

  if (databaseName) {
    headers["beehive-database-name"] = databaseName;
  }

  return headers;
};

export const addressCheckApi = (body, callback) => {
  fetch(
    `${apicultureUrl}/api/v1/USPS/addresses/validate?` +
    new URLSearchParams(
      Object.fromEntries(
          Object.entries(body).filter(([_, value]) => value !== null && value !== undefined)
        )
      ),
    {
      method: "GET"
    },
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      return null;
    })
    .then((data) => {
      callback(data);
    });
};

export const api = (endpoint, body, callback) => {
  fetch(baseUri + endpoint, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((data) => {
      callback(data);
    });
};

export const apiAuth = (endpoint, body, callback) => {
  const getKey = window.getKey;

  const fetchWithHeaders = (key) => {
    fetch(baseUri + endpoint, {
      method: "POST",
      headers: buildHeaders(key),
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        callback(data);
      });
  };

  if (isAuthDisabled || !getKey) {
    fetchWithHeaders();
    return;
  }

  getKey((key) => fetchWithHeaders(key));
};

export const formatToCurrency = (amount) => {
  return "$" + (amount / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
